import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import RoomContext from "../../context/RoomContext";
import { FormattedMessage } from "react-intl";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import * as roomActions from "../../actions/roomActions";
import * as callActions from "../../actions/callActions";
import { Hidden } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    dialogTitle: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    dialogPaper: { width: "auto" },
    buttonEndForAll: {
      marginTop: 0,
      color: "#ffffff",
      backgroundColor: "#F3465A ",
      "&:hover": {
        backgroundColor: "#e12626",
      },
    },
    downloadTranscriptButton: {
      marginTop: 0,
    },
    leaveButton: {
      marginTop: 0,
      color: "#F3465A",
      backgroundColor: "#ffffff",
      "&:hover": {
        backgroundColor: "rgba(50,137,239,0.11)",
      },
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: "#181C1E",
      border: "1px solid #EAEDF0",
    },
  })
);

const LeaveDialog = ({
  isModerator,
  hasWebinarPermission,
  webinar,
  currentCall,
  open = true,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { roomClient } = useContext(RoomContext);
  const [leaving, setLeaving] = useState(false);

  const handleClose = () => {
    if (leaving) return;
    dispatch(roomActions.setLeaveDialogOpen({ leaveDialogOpen: false }));
  };

  const handleLeaveMeeting = async () => {
    if (leaving) return;
    setLeaving(true);
    dispatch(roomActions.setLeaveDialogOpen({ leaveDialogOpen: false }));
    // close() currentCall'ı temizlemeden önce sunucuya endCall için sakla
    const callSnapshot = currentCall;
    try {
      // Önce odayı kapat (_closed + call clear → AutoBusy tekrar busy basmaz)
      roomClient.close(true);
      if (callSnapshot && callSnapshot.group && callSnapshot.roomId) {
        try {
          await dispatch(
            callActions.endCall(callSnapshot.group.id, callSnapshot.roomId)
          );
        } catch (e) {
          /* ignore */
        }
      }
    } finally {
      setLeaving(false);
    }
  };

  const handleEndForAll = async () => {
    if (leaving) return;
    setLeaving(true);
    dispatch(roomActions.setLeaveDialogOpen({ leaveDialogOpen: false }));
    const callSnapshot = currentCall;
    try {
      await roomClient.closeMeeting();
      if (callSnapshot && callSnapshot.group && callSnapshot.roomId) {
        try {
          await dispatch(
            callActions.endCall(callSnapshot.group.id, callSnapshot.roomId)
          );
        } catch (e) {
          /* ignore */
        }
      }
    } finally {
      setLeaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick={leaving}
      disableEscapeKeyDown={leaving}
      classes={{
        paper: classes.dialogPaper,
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h5">
          <FormattedMessage
            id="label.leaveMeeting"
            defaultMessage="Leave Meeting"
            disableTypography
            className={classes.dialogTitle}
          />
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage
            id="room.leave"
            defaultMessage="Are you sure you want to leave the meeting?"
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {((isModerator && !webinar) || (hasWebinarPermission && webinar)) && (
          <Button
            onClick={handleEndForAll}
            disabled={leaving}
            className={classes.buttonEndForAll}
          >
            <FormattedMessage
              id="label.endMeetingForAll"
              defaultMessage="End Meeting For All"
            />
          </Button>
        )}
        <Hidden xsDown>
          {isModerator && (
            <Button
              onClick={() => roomClient.downloadTranscript()}
              disabled={leaving}
              className={classes.downloadTranscriptButton}
            >
              <FormattedMessage
                id="label.downloadTranscript"
                defaultMessage="Download Transcript"
              />
            </Button>
          )}
        </Hidden>
        <Button
          onClick={handleLeaveMeeting}
          disabled={leaving}
          className={classes.leaveButton}
        >
          <FormattedMessage
            id="label.leaveMeeting"
            defaultMessage="Leave Meeting"
          />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

LeaveDialog.propTypes = {
  open: PropTypes.bool,
  isModerator: PropTypes.bool,
  webinar: PropTypes.bool,
  hasWebinarPermission: PropTypes.bool,
  currentCall: PropTypes.object,
};
export default LeaveDialog;
